module.exports = __webpack_public_path__ + "img/security.43776454.svg";